export default __webpack_public_path__ + "static/media/wf-isf-perspectives-solar-projects_767x577.a936a6f7.jpg";